export default __webpack_public_path__ + "images/aceceb07576454b7368fb356397a453c-endocrine_icon.png";